<template>
  <v-card flat tile>
    <v-card-text>
          <v-row no-gutters>
            <v-col cols="12">
              <budget-page-header :title="selectedGroupName || 'GL Accounts'" :budgetIterationId="budgetIterationId"></budget-page-header>
            </v-col>
          </v-row>
          <v-row no-gutters>
          </v-row>
          <router-view></router-view>
    </v-card-text>
    <!-- Actions -->
    <v-card-actions>
      <v-spacer></v-spacer>
    </v-card-actions>
    <!-- Dialog Instances -->
    <publish-budget-dialog
      v-if="showPublishBudgetDialog"
      :showDialog="showPublishBudgetDialog"
      @confirm-publish="publishBudget"
      @cancel-publish="closePublishBudgetDialog">
    </publish-budget-dialog>
    <!-- TODO - turn info and error dialogs into vuex store items (good candidates for vuex) -->
    <info-dialog 
      v-if="showInfoDialog"
      :showDialog="showInfoDialog"
      :message="infoDialogMessage"
      :title="infoDialogTitle"
      @cancelError="closeInfoDialog">
    </info-dialog>
  </v-card>
</template>

<script>
  import BudgetPageHeader from '@/components/budgets/common/BudgetPageHeader';
  import InfoDialog from '@/components/base/dialogs/InfoDialog.vue';
  import PublishBudgetDialog from '../dialogs//PublishBudgetDialog.vue';
  import budgetService from '@/services/budget';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'GeneralLedger',
    components: {
      BudgetPageHeader,
      InfoDialog,
      PublishBudgetDialog
    },
    props: {
      budgetIterationId: {
        required: true
      }
    },
    data: function () {
      return {
        showInfoDialog: false,
        infoDialogTitle: '',
        infoDialogMessage: '',
        showPublishBudgetDialog: false,
      };
    },
    computed: {
      ...mapGetters(['selectedGroupName']),
      currentData() {
        return this[this.currentDataKey]
      }
    },
    methods: {
      ...mapActions(['changeLoading', 'activateErrorDialog']),
      back() {
        // right now just swap to turnover worksheet
        this.$emit('changeComponent', 'Landing');
      },
      closeInfoDialog() {
        this.showInfoDialog = false;
        this.infoDialogTitle = '';
        this.infoDialogMessage = '';
      },
      exportBudget() {},
      openPublishBudgetDialog() {
        this.showPublishBudgetDialog = true;
      },
      closePublishBudgetDialog() {
        this.showPublishBudgetDialog = false;
      },
      async publishBudget() {
        this.changeLoading(true);
        var result = await budgetService.publishBudget(this.budgetIterationId, this.budgetDescriptionData.lastModifiedTimestamp);
        if (!result) {
          // Official error messages?
          //this has been handled generically in services/api/index.js
          //this.activateErrorDialog({message: 'Something went wrong publishing the budget. Please try again or contact support for further assistance.'});
        } else {
          this.infoDialogTitle = 'Publish Succeeded'; 
          this.infoDialogMessage = 'Budget Successfully Published!';
          this.showInfoDialog = true;
        }
        this.closePublishBudgetDialog();
        this.changeLoading(false);
      }
    },
    async mounted() {
    }
  }
</script>

<style lang="scss" scoped>
  .v-tabs::v-deep .v-tabs-bar {
    height: 56px;
  }

  .v-tabs .v-tab {
    font-size: 12px;
    width: 125px !important;
    min-width: 125px !important;
    max-width: 125px !important;
    height: 56px;
    border: 1px solid var(--v-resGrey-lighten3) !important;
    color: var(--v-resBlue-darken1) !important;
    text-transform: none !important;
  }
    .v-tabs .v-tab.v-tab--active {
      background-color: var(--v-resBlue-base) !important;
      color: white !important;
    }

  .collapse-button {
    position: absolute;
    left: 0;
    top: -40px;
  }
</style>
